module.exports = __webpack_public_path__ + "static/media/opyn.b27d6bcf.svg";